'use strict';

angular.module('substoreApp.services')
    .service('webtrekk', ['$rootScope', 'sessionData', 'umlautTranslator', '$q', 'asyncI18nLoader', '$filter', '$log',
        function ($rootScope, sessionData, umlautTranslator, $q, asyncI18nLoader, $filter, $log) {
            var loader = null;
            var utag_data = null;
            var first_call = true;

            return {
                track: function (page_content_suffix, data) {
                    var deferred = $q.defer();

                    function init() {
                        if (loader != null) return loader;
                        loader = $q.defer();
                        $.getScript(sessionData.dialogStaticData.webtrekkTealiumURL, function (data2, textStatus, jqxhr) {
                            if (jqxhr.status) {
                                loader.resolve();
                            } else {
                                loader.reject();
                            }
                        });
                        return loader;
                    }

                    function htmlDecode(text) {
                        // decodes html entities such as '&auml;' back to 'ä' etc.
                        // see http://stackoverflow.com/questions/10715801/javascript-decoding-html-entities
                        return $("<div/>").html(text).text();
                    }

                    function simplify(text) {
                        return umlautTranslator(htmlDecode(text))
                            .toLowerCase()
                            .replace(/[ ]+/g, "-")
                            .replace(/[^a-z0-9_-]/g, "");
                    }

                    sessionData.promise.then(function () {
                        if (sessionData.dialogStaticData.enableWebtrekkIntegration) {
                            var page_content_id = window.location.host;
                            page_content_id += "." + simplify($filter('i18n')('webtrekk_invokingportal_all'));// + simplify(sessionData.dialogStaticData.invokingPortalKey);
                            page_content_id += "." + simplify($filter('i18n')('webtrekk_' + page_content_suffix));

                            if (typeof data['page_content_id'] != 'undefined') {
                                data['page_content_id'] = page_content_id + '.' + simplify(data['page_content_id']);
                            } else {
                                data['page_content_id'] = page_content_id;
                            }

                            if (typeof data['page_type'] == 'undefined') {
                                data['page_type'] = 'basket';
                            }

                            if (typeof data['shop_product_name'] != 'undefined') {
                                data['shop_product_name'] = htmlDecode(data['shop_product_name'].toString());
                            }

                            $log.info("web tracking data for " + page_content_suffix + ":");
                            $log.info(data);

                            if (!utag_data) {
                                utag_data = document.createElement('script');
                                utag_data.setAttribute('type', 'text/javascript');
                                utag_data.innerHTML = 'var utag_data = ' + JSON.stringify(data) + ';';
                                document.body.appendChild(utag_data);
                            }

                            init().promise.then(function () {
                                if (!first_call) {
                                    utag.view(data);
                                }
                                first_call = false;
                                deferred.resolve(true);
                            });
                        } else {
                            deferred.resolve(true);
                        }
                    });

                    return deferred;
                }
            };
        }]);